import { SelectField } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { useGetSelectOptions } from '../hooks';

interface AssociatedProfileTypeFilterProps {
    name: string;
    helper?: React.ReactNode;
    typeOptions?: object;
    isDisabled?: boolean;
}

export const AssociatedProfileTypeFilter = ({
    name,
    helper,
    typeOptions = {},
    isDisabled,
}: AssociatedProfileTypeFilterProps) => {
    const options = useGetSelectOptions(typeOptions);

    return (
        <SelectField
            data-test-id="associated-profile-type-filter"
            showSelectAll
            label={lt('LedgerFilterAssociatedProfileType')}
            name={name}
            helper={helper}
            options={options}
            multiselect
            disabled={isDisabled}
        />
    );
};
